<!-- App.svelte -->
<script>
  import { onMount, tick } from 'svelte';
  import { loadSelectedOption, saveSelectedOption, loadQuickSelect, saveQuickSelect } from './lib/storage.js';
  let selectedOption = '' // Początkowa wartość wybranej opcji
  let initialized = false

  let buttonSign = '+'
  let quickSelect = []
  const civilizations = ['Aztekowie', 'Majowie', 'Grecja', 'Persja', 'Rzym', 'Polacy', 'Fenicjanie', 'Babilonczycy', 'Kartagina', 'Indie', 'Japonia', 'Chiny', 'Egipt', 'Celtowie', 'Hunowie', 'Wikingowie', 'Zulusi'].sort()

  // Funkcja do zmiany treści w divie na podstawie wybranej opcji
  function updateContent() {
    const imgElements = document.getElementsByClassName('civilization_image')
    Array.from(imgElements).forEach((element, index) => {
      element.src = `images/${selectedOption.toLowerCase()}_${index}.png`
    })
    buttonSignChange()
  }

  function addToQuickSelect() {
    if (!quickSelect.includes(selectedOption)) {
      quickSelect.push(selectedOption)
      quickSelect = quickSelect.filter((element, index, array) => array.length - index <= 5);
    } else {
      quickSelect.splice(quickSelect.indexOf(selectedOption), 1)
      quickSelect = quickSelect
    }
    console.log(quickSelect)
    buttonSignChange()
  }

  function buttonSignChange() {
    if (!quickSelect.includes(selectedOption)) {
      buttonSign = '+'
    } else {
      buttonSign = '-'
    }
  }

  function changeSelected(civilization) {
    if(selectedOption !== civilization) {
      selectedOption = civilization
      updateContent()
    }
  }

  onMount(async () => {
    selectedOption = loadSelectedOption()
    quickSelect = loadQuickSelect()
    buttonSignChange()
    // wait for Svelte to render any conditional DOM (the <img> elements)
    await tick()
    if (selectedOption) updateContent()
    initialized = true
  })

  // persist when values change (only after initial load)
  $: if (initialized) saveSelectedOption(selectedOption)
  $: if (initialized) saveQuickSelect(quickSelect)
</script>

<main>
  <h2>Cywilizacje</h2>
  <div class="quick-list">
    {#each quickSelect as civilization}
      <button on:click={() => changeSelected(civilization)}>{civilization}</button>
    {/each}
  </div>
  <div class="select-container">
    <button on:click={addToQuickSelect} class="add-button {buttonSign === '+' ? 'green' : 'red'}" disabled={selectedOption === '' ? true : false}>{buttonSign}</button>
    <select bind:value={selectedOption} on:change={updateContent}>
      <option value="" disabled>Wybierz cywilizację</option>
      {#each civilizations as civilization }
        <option value={civilization}>{civilization}</option>
      {/each }
    </select>
  </div>

  <div>
    {#if selectedOption !== ''}
      <img class="civilization_image" alt="Cywilizacja">
      <img class="civilization_image" alt="Lider 1">
      <img class="civilization_image" alt="Lider 2">
      <img class="civilization_image" alt="Lider 3">
    {/if}
  </div>
</main>

<style>
  main {
    text-align: center;
    padding: 0;
    margin: 0 10px;
  }

  .select-container {
    display: flex;
    justify-content: center;
  }

  select {
    min-width: 170px;
    margin-block: 0.5rem;
    display: block;
    cursor: pointer;
    padding: 0.375rem 2.25rem 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: normal;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' %3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 16px 12px;
    border: 1px solid #ced4da;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  select:focus {
    border-color: #86b7fe;
    outline: 0;
    box-shadow: 0 0 0 0.15rem rgb(13 110 253 / 25%);
  }

  img {
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    display: block;
    height: auto;
    margin-bottom: 1em;
  }

  .quick-list button {
    margin-left: 0.2em;
    cursor: pointer;
  }

  .add-button {
    order: 2;
    cursor: pointer;
    margin-left: 10px;
    margin-block: calc(0.5rem + 2px);
    height: 34px;
    border: none;
    display: block;
    width: 2em;
    outline-style: solid;
    outline-width: 2px;
    background-color: #eee;
  }

  .add-button.green {
    outline-color: green;
    color: green;
  }
  .add-button.red {
    outline-color: red;
    color: red;
  }
  .add-button:disabled {
    visibility: hidden;
  }
</style>